<template>
  <div class="container">
    <div class="nav_wrapper ">
      <div class="w">
        <div class="logo">
          <!-- <img :src="this.$store.state.marketInfo.logo" alt="" /> -->
          <h1 @click="toHomePage">{{ this.$store.state.marketInfo.title }}</h1>

          <!-- <div class="city">
            <el-dropdown @command="cityChange">
              <span class="el-dropdown-link">{{ cityName || '城市' }}<i class="el-icon-arrow-down el-icon--right"></i> </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="item in cityList" :key="item.value" :command="item.value">{{ item.text }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div> -->
        </div>

        <div class="nav">
          <span :class="{ active: item.cCode == menuActive }" v-for="item in menuList" :key="item.cCode" @click="togglePage(item.cCode, item.menuParameter)">{{ item.menuName }}</span>

          <span class="tel">{{ this.$store.state.marketInfo.tel }}</span>
        </div>
        <!-- <div class="login">
        <span v-if="this.$store.state.token" class="login_box">{{ this.$store.state.userInfo.name }}</span>
        <span v-if="this.$store.state.token" class="login_box">
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">操作<i class="el-icon-arrow-down el-icon--right"></i> </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="a">修改账号</el-dropdown-item>
              <el-dropdown-item command="b">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </span>
        <span @click="login" v-else class="login_box">登录</span>
        <span>客服热线：025-58006868</span>
      </div> -->
      </div>
    </div>
    <div :style="{ 'min-height': height + 'px' }">
      <router-view :city="city" @togglePage="togglePage2($event)"></router-view>
    </div>
    <!-- 页脚 -->
    <page-footer></page-footer>

    <!-- 登录框 -->
    <!-- <el-dialog title="登录" :visible.sync="loginDialog" width="35%" center>
        <div style="paddingRight:40px;">
          <el-form :model="loginForm" status-icon ref="loginForm" :rules="loginRules" label-width="60px">
            <el-form-item label="账号" prop="loginName">
              <el-input type="loginName" v-model="loginForm.loginName" placeholder="请输入账号" size="medium"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="pass">
              <el-input type="password" v-model="loginForm.pass" placeholder="请输入密码" size="medium" show-password></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer">
          <el-button @click="resetLoginForm('loginForm')">重置</el-button>
          <el-button type="primary" @click="submitLoginForm('loginForm')">提交</el-button>
        </span>
      </el-dialog> -->

    <!-- 修改密码框 -->
    <!-- <el-dialog title="修改密码" :visible.sync="modifyDialog" width="40%" center>
        <div style="paddingRight:40px;">
          <el-form :model="modifyForm" status-icon ref="modifyForm" :rules="modifyRules" label-width="70px">
            <el-form-item label="原密码" prop="oldPwd">
              <el-input type="password" v-model="modifyForm.oldPwd" placeholder="请输入原密码" size="medium" show-password></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPwd">
              <el-input type="password" v-model="modifyForm.newPwd" placeholder="请输入新密码" size="medium" show-password></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer">
          <el-button @click="resetModifyForm('modifyForm')">重置</el-button>
          <el-button type="primary" @click="submitModifyForm('modifyForm')">提交</el-button>
        </span>
      </el-dialog> -->
  </div>
</template>

<script>
import menus from '../utils/menu'

export default {
  data() {
    return { menuList: [], city: '', cityList: [], height: '' }
  },
  created() {
    this.height = window.screen.availHeight - 140
    // 城市
    this.getCityList()
    // 菜单
    this.getMenuList()
    // 市场信息
    this.findIndexInfo()
  },
  methods: {
    async findIndexInfo() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/index/findIndexInfo')
      if (data.success) {
        this.marketInfo = data.data.info
        document.title = this.marketInfo.sitename
        this.$store.commit('setMarketInfo', this.marketInfo)
      }
    },
    async getCityList() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/config/listArea')
      if (data.success) {
        this.cityList = data.data.list
      }
    },
    async getMenuList() {
      var menuList = window.sessionStorage.getItem('menuList')
      if (menuList) {
        this.menuList = JSON.parse(menuList)
        return false
      }
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/menu/menuList?kindId=1')
      if (data.success) {
        var menuList2 = []
        for (var item of data.data.page) {
          for (var key in menus) {
            if (item.cCode == key) {
              menuList2.push(item)
            }
          }
        }
        this.menuList = menuList2
        window.sessionStorage.setItem('menuList', JSON.stringify(this.menuList))
      }
    },
    togglePage(name, menuParameter) {
      if (this.$route.name == name) {
        return false
      }
      if (name == 'YuanTongAuction') {
        // 拍卖
        window.open('https://www.ytpai.com')
      } else {
        this.$store.commit('setMenuActive', name)
        this.$router.push({
          path: menus[name],
          query: {
            pageId: menuParameter
          }
        })
      }
    },
    toHomePage() {
      if (this.$route.name == 'Home') {
        return false
      }
      this.$store.commit('setMenuActive', 'Home')
      this.$router.push({
        path: '/home'
      })
    },
    cityChange(value) {
      this.city = value
    }
  },
  watch: {
    city(val, oldVal) {
      sessionStorage.setItem('city', val)
    }
  },
  computed: {
    cityName() {
      var index = this.cityList.findIndex(item => item.value == this.city)
      console.log(12)
      if (index != -1) {
        var text = this.cityList[index].text
        return text
      } else {
        return ''
      }
    },
    menuActive() {
      return this.$store.state.menuActive || ''
    }
  }
}
</script>

<style lang="less" scoped>
.el-dropdown-link {
  cursor: pointer;
  color: #fff;
}
.nav_wrapper {
  height: 60px;
  background-color: #333;
}
.nav_wrapper .w {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .logo {
    height: 60px;
    display: flex;
    align-items: center;
    cursor: pointer;
    img {
      width: 60px;
      height: 60px;
      object-fit: cover;
      border-radius: 50%;
      margin-right: 20px;
    }
    h1 {
      font-size: 20px;
      color: #fff;
      margin-right: 20px;
    }
    .city {
      width: 80px;
    }
  }

  .nav {
    display: flex;
    justify-content: flex-end;
    span {
      cursor: pointer;
      color: #fff;
      margin: 0 20px;
      font-size: 14px;
      line-height: 2;
    }
    span:hover {
      font-weight: 700;
    }
    .active {
      border-bottom: 2px solid #fff;
    }
    .tel {
      &:hover {
        font-weight: 400;
      }
      cursor: default;
    }
  }
  .login {
    .el-dropdown {
      display: inline-block;
      position: relative;
      color: #444;
      font-size: 16px;
    }
    .login_box {
      border-right: 1px solid #ccc;
      margin-right: 5px;
      padding-right: 5px;
      cursor: pointer;
    }
  }
}
</style>
